import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IParent, IStudent } from '../../../../models/students.model';
import useAxios from '../../../../hooks/useAxios';
import StudentName from '../Name';
import {
  IGetStudentMessage,
  ISendMessageReq,
  IStudentMessage,
} from '../../../../models/pushMessage.model';
import { DatePicker, DatePickerProps } from 'antd';
import moment, { Moment } from 'moment';
import {
  getStudentMessages,
  sendMessages,
  sendMultiMessages,
} from '../../../../api/pushMessage.api';
import StudentMessageTable from './StudentMessageTable';
import SendMessageModal from './modals/SendMessageModal';
import ErrorResponse from '../../../ErrorResponse';
import Loader from '../../../Loader';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';
import useNotification from '../../../../hooks/useNotification';
import { RangePickerProps } from 'antd/es/date-picker';
import Radio from '../../../Radio';

interface IProps {
  student?: IStudent;
  parent?: IParent
}

const StudentMessage: FC<IProps> = ({
  student,
  parent,
}) => {
  const { t } = useTranslation();
  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetStudentMessage>();
  const {
    data: createRes,
    isLoading: createIsLoading,
    error: createError,
    execute: createExecute,
  } = useAxios();
  const { currentCampus } = useSelector((root: RootState) => root.auth);
  const { campusData } = useSelector((root: RootState) => root.campusData);
  const { successNotification } = useNotification();

  const [data, setData] = useState<IStudentMessage[]>([]);
  const [sendGBN, setSendGBN] = useState('AP');
  const [date, setDate] = useState(moment());
  const [visible, setVisible] = useState(false);
  const [pk, setPk] = useState<number>();

  const onChange: DatePickerProps['onChange'] = (value: Moment | null) => {
    value && setDate(value);
  };

  useEffect(() => {
    if (student) {
      doGetStudentMessages();
    }
  }, [student, date]);

  useEffect(() => {
    if (res && !isLoading) {
      setData(res.data.filter(item => item.sendGBN === sendGBN));
    }
  }, [res, isLoading, sendGBN]);

  useEffect(() => {
    if (createRes && !createIsLoading) {
      successNotification(t('student.student.message46'));
      doGetStudentMessages();
      onCancel();
    }
  }, [createRes, createIsLoading]);

  const doGetStudentMessages = () => {
    if (student) {
      execute(
        getStudentMessages(student.studentCode, {
          month: date.month() + 1,
          year: date.year(),
        }),
      );
    }
  };

  const showModal = (pk?: number) => {
    if (pk !== undefined) setPk(pk);
    setVisible(true);
  };

  const onCancel = () => setVisible(false);
  /*
  const onOk = (
    data: Omit<ISendMessageReq, 'campusCode' | 'outgoingNumber'>,
  ) => {
    const campus = campusData.find(
      ({ campusCode }) => campusCode === currentCampus,
    );
    student &&
      campus &&
      createExecute(
        sendMessages({
          ...data,
          campusCode: campus.campusCode,
          memberCode: [student.studentCode],
          outgoingNumber: campus.telephoneNo,
        }),
      );
  };
  */

  const onMultiOk = (data: ISendMessageReq[]) => {
    createExecute(sendMultiMessages(data));
  };

  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    const userCurrent = moment(moment().format('YYYY-MM-DD'));
    const dateCurrent = moment(current.format('YYYY-MM-DD'));
    return dateCurrent.isAfter(userCurrent);
  };

  return (
    <>
      {(isLoading || createIsLoading) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={createError} />
      <StudentName student={student} />
      <div className="comm-bx__space">
        <div className='radio-area justify-content-end'>
          <div className="radio-wrapper">
            <Radio
              checked={sendGBN === 'AP'}
              onChange={() => setSendGBN('AP')}
              text="PUSH"
            />
            <Radio
              checked={sendGBN === 'ME'}
              onChange={() => setSendGBN('ME')}
              text="SMS"
            />
          </div>
          <div className="date-picker__area">
            <DatePicker
              disabledDate={disabledDate}
              onChange={onChange}
              picker="month"
              value={date}
            />
          </div>
        </div>
      </div>
      <StudentMessageTable
        showModal={showModal}
        data={data}
      />

      {visible && (
        <SendMessageModal
          data={pk && res ? data?.find(item => item.pk === pk) : undefined}
          visible={visible}
          parent={parent}
          student={student}
          onCancel={onCancel}
          onMultiOk={onMultiOk}
        />
      )}
    </>
  );
};

export default StudentMessage;
